<div class="d-flex fd-col vh-100 overflow-y-auto custom-scrollbar" tabindex="0">
  <ng-container *ngIf="ActiveSensor === undefined; else SelectedSensor">
      <div class="justify-content-center d-flex align-items-center h-100">
        <h3 class="not-find-sensor text-align-center"> Selecciona un sensor para visualizar detalles del mismo </h3>
      </div>
  </ng-container>
  <ng-template #SelectedSensor>
    <div class="contenedor-sensor">
      <p class="title-card d-flex text-size-22 text-justify">
        Sensor {{ActiveSensor?.idSensor}}
      </p>
      <p class="subtitle-card d-flex text-size-18 text-weight-500 text-justify">
        {{ActiveSensor?.originName || 'Plaza de San Pedro, s/n, 04001'}}
      </p>

      <div class="grid-container text-white text-weight-600">
        <div class="card-title">
          <span class="text-size-16 mb-05 text-color-primary-1 text-weight-500">{{formatDate?.start }}</span>
          <span class="text-size-16 mb-05 text-color-primary-1 text-weight-500">{{formatDate?.end }}</span>
          <span class="text-size-16 mb-05 text-weight-500">Fecha y hora inicio</span>
          <span class="text-size-16 mb-05 text-weight-500">Fecha y hora fin</span>
        </div>
      </div>

    </div>

    <div class="d-flex fd-col mb-32">
      <div class="bg-color-background-1 d-flex mb-16">
        <div class="left-subtitle-block bg-color-primary-1"></div>
        <div class="d-flex full-width py-05">
          <sit-icon [icon]="Icon.sensor_matriz_w" class="ml-28" [sizeClass]="'icon-size-32'"
                    alt="icono sensor matriz origen"></sit-icon>
          <h3 class="flex-grow text-weight-600 text-size-24 ml-16 text-md-size-18 text-color-white align-self-center">
            Porcentaje por Sensor
          </h3>
        </div>
      </div>

      <div *ngFor="let item of ActiveSensor.sensor" class="contenedor-sensor">
        <p class="title-card d-flex text-size-18 text-justify text-weight-500">
          Sensor {{item?.idSensor}} - {{item?.name}}
        </p>
        <p class="subtitle-card d-flex text-size-16 text-justify text-weight-500">
          {{item?.address}}
        </p>

        <div class="grid-container text-white text-weight-600">
          <div class="card">
            <span class="text-size-18 mb-05 text-color-primary-1-dark">{{(item?.percentage).toFixed(0)}}%</span>
            <span class="text-size-18 mb-05 text-color-primary-1-dark">{{item?.count}}</span>
            <span class="text-size-14 mb-05">Proporción <br> {{ActiveSensor?.typeSensor === 'ARRIVALS' ? 'origen' : 'destino'}}</span>
            <span class="text-size-14 mb-05">Dispositivos</span>
          </div>
          <!-- <div class="card">
            <span class="text-size-18 mb-05 text-color-primary-1-dark">40%</span>
            <span class="text-size-18 mb-05 text-color-primary-1-dark">110</span>
            <span class="text-size-14 mb-05">Proporción <br> origen</span>
            <span class="text-size-14 mb-05">Dispositivos</span>
          </div> -->
        </div>
      </div>
    </div>
  </ng-template>
</div>
